const AnalysisMargin = () => {
  return (
    <section>
      <div className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
                    role="tab" aria-controls="home" aria-selected="true"> risk margin (var margin)</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button"
                    role="tab" aria-controls="profile" aria-selected="false"> extreme loss margin</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button"
                    role="tab" aria-controls="contact" aria-selected="false"> mark-to-mark margin</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="initial-tab" data-bs-toggle="tab" data-bs-target="#initial" type="button"
                    role="tab" aria-controls="initial" aria-selected="false">initial margin</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="exposure-tab" data-bs-toggle="tab" data-bs-target="#exposure" type="button"
                    role="tab" aria-controls="exposure" aria-selected="false"> exposure margin</button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                  <div className="about__wrapper">
                    <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
                      <div className="col-lg-5">
                        <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                          <div className="about__thumb-inner">
                            <div className="about__thumb-image floating-content">
                              <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-7">
                        <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                          <div className="about__content-inner">
                            <h4 className="meet-oppurtanity">Value at Risk Margin [VaR margin] <span> </span></h4>
                            <p>All securities are classified into three groups for the purpose of VaR margin</p>
                            <ul className="tab-list">
                              <li>For the securities listed in Group I, scrip wise daily volatility calculated using the
                                exponentially weighted moving average methodology is applied to daily returns. The scrip
                                wise daily VaR is 3.5 times the volatility so calculated subject to a minimum of 7.5%.
                              </li>
                              <li>For the securities listed in Group II, the VaR margin is higher of scrip VaR (3.5 sigma)
                                or three times the index VaR, and it is scaled up by root 3.</li>
                              <li>The index VaR, for the purpose, is the higher of the daily Index VaR based on S&P CNX
                                NIFTY or BSE SENSEX, subject to a minimum of 5%.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                  <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
                    <div className="col-lg-5">
                      <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                        <div className="about__thumb-inner">
                          <div className="about__thumb-image floating-content">
                            <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                        <div className="about__content-inner">
                          <h4 className="meet-oppurtanity">Extreme Loss Margin <span> </span></h4>
                          <p><b>The Extreme Loss Margin for any security is higher of: 5%, or</b></p>
                          <p>1.5 times the standard deviation of daily logarithmic returns of the security price in the
                            last six months. This computation is done at the end of each month by taking the price data on
                            a rolling basis for the past six months and the resulting value is applicable for the next
                            month.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                  <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
                    <div className="col-lg-5">
                      <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                        <div className="about__thumb-inner">
                          <div className="about__thumb-image floating-content">
                            <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                        <div className="about__content-inner">
                          <h4 className="meet-oppurtanity">mark-to-mark margin <span> </span></h4>
                          <p>Mark to market loss is calculated by marking each transaction in security to the current
                            market price. In case the net outstanding position in any security is nil, the difference
                            between the buy and sell values shall be considered as notional loss for the purpose of
                            calculating the mark to market margin payable.</p>
                          <h4 className="meet-oppurtanity">Futures and Options</h4>
                          <p>The actual margining and position monitoring is done on-line, on an intra-day basis. NSCCL
                            uses the SPAN® (Standard Portfolio Analysis of Risk) system for the purpose of margining,
                            which is a portfolio based system.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="initial" role="tabpanel" aria-labelledby="initial-tab">
                  <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
                    <div className="col-lg-5">
                      <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                        <div className="about__thumb-inner">
                          <div className="about__thumb-image floating-content">
                            <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                        <div className="about__content-inner">
                          <h4 className="meet-oppurtanity">initial margin <span> </span></h4>
                          <h6>Span Margin</h6>
                          <p>Initial margin requirements are based on 99% value at risk over a one day time horizon.
                            However, in the case of futures contracts (on index or individual securities), where it may
                            not be possible to collect mark to market settlement value, before the commencement of trading
                            on the next day, the initial margin is computed over a two-day time horizon, applying the
                            appropriate statistical formula. The methodology for computation of Value at Risk percentage
                            is as per the recommendations of SEBI from time to time.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="exposure" role="tabpanel" aria-labelledby="exposure-tab">
                  <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
                    <div className="col-lg-5">
                      <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                        <div className="about__thumb-inner">
                          <div className="about__thumb-image floating-content">
                            <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                        <div className="about__content-inner">
                          <h4 className="meet-oppurtanity">initial margin <span> </span></h4>
                          <p>The exposure margins for options and futures contracts on index are as follows:</p>
                          <p>For Index options and Index futures contracts:</p>
                          <ul className="tab-list">
                            <li>3% of the notional value of a futures contract. In case of options it is charged only on
                              short positions and is</li>
                            <li>3% of the notional value of open positions.</li>
                          </ul>
                          <p>For option contracts and Futures Contract on individual Securities:</p>
                          <ul className="tab-list">
                            <li>The higher of 5% or 1.5 standard deviation of the notional value of gross open position in
                              futures on individual securities and gross short open positions in options on individual
                              securities in a particular underlying. The standard deviation of daily logarithmic returns
                              of prices in the underlying stock in the cash market in the last six months is computed on a
                              rolling and monthly basis at the end of each month.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalysisMargin;